import styled from "@emotion/styled";

export const Header = styled.header`
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  background-color: white;
  max-width: 440px;
  min-width: 320px;
  width: 100%;
  height: 60px;
  margin: auto;
  font-size: 1.2rem;
  font-weight: bold;
  z-index: 999;
`